import React from "react";
import { Link } from "react-router-dom";

const AppLauncherButton = ({
  name,
  icon,
  path = "#",
  disabled = false,
  onClick,
}) => {
  const baseClasses =
    "flex flex-col items-center justify-between w-24 h-28 p-2 rounded-xl transition hover:bg-tier-secondary/10";
  const disabledClasses = "opacity-50 cursor-not-allowed pointer-events-none";

  return (
    <Link
      to={disabled ? "#" : path}
      onClick={onClick}
      className={`${baseClasses} ${disabled ? disabledClasses : ""}`}
    >
      {/* Icon Circle */}
      <div
        className={`flex items-center justify-center w-12 h-12 rounded-full ${
          disabled
            ? "bg-white/10 text-white/50"
            : "bg-white/20 text-tier-secondary"
        }`}
      >
        <span className="material-symbols-outlined text-3xl">{icon}</span>
      </div>

      {/* App Name */}
      <p className="text-xs text-center text-white leading-tight line-clamp-2 max-w-[4.5rem]">
        {name}
      </p>
    </Link>
  );
};

export default AppLauncherButton;
